const NSFW_CONTAINER_URL = "http://137.184.93.100:8000";

export async function checkContainer(): Promise<boolean> {
	try {
		const response = await fetch(
			`https://pculwozsgokcvecdekjo.supabase.co/functions/v1/cors-proxy?url=${NSFW_CONTAINER_URL}`,
			{
				method: "GET",
				cache: "no-cache",
				signal: AbortSignal.timeout(5000)
			}
		);

		return response.status === 404;
	} catch (ex) {
		if ((ex as Error).name == "AbortError") {
			return false;
		}
	}

	return false;
}
